import  {adminApi}  from "./api";

const BASE_URL = "/api/v1/category";

export const getCategoriesApi = () => {
  return adminApi.get(`${BASE_URL}/`);
};

export const getCategoryByIdApi = (id) => {
  return adminApi.get(`${BASE_URL}/${id}`);
};

export const getCategoriesAdminApi = () => {
  return adminApi.get(`${BASE_URL}/list/all`);
};

export const createCategoryApi = (data) => {
  return adminApi.post(`${BASE_URL}/create`, data);
};

export const updateCategoryApi = (id, data) => {
  return adminApi.put(`${BASE_URL}/${id}`, data);
};

export const deleteCategoryApi = (id) => {
  return adminApi.delete(`${BASE_URL}/${id}`);
};
